/* External */
import {
  memo, useCallback, useEffect, useState,
} from 'react';
import PropTypes from 'prop-types';

/* Utils */
import { LANDER_LOGO_BASE_IMAGE_URL } from '../../utils/constants';

/* Styles */
import './LanderLogo.scss';

function LanderLogo({
  className, landerName, small, hidden,
}) {
  const [isError, setIsError] = useState(false);

  const handleError = useCallback(() => {
    setIsError(true);
  }, []);

  useEffect(() => {
    setIsError(false);
  }, [landerName]);

  return (
    <div
      className={`dtv-html5-c-lander-logo ${
        small ? 'dtv-html5-c-lander-logo--small' : ''
      } ${
        hidden ? 'dtv-html5-c-lander-logo--hidden' : ''
      } ${className}`}
    >
      {!isError && (
        <img
          className="dtv-html5-c-lander-logo__image"
          src={`${LANDER_LOGO_BASE_IMAGE_URL}/${landerName}.png`}
          alt={landerName}
          onError={handleError}
        />
      )}
    </div>
  );
}

LanderLogo.propTypes = {
  className: PropTypes.string,
  landerName: PropTypes.string.isRequired,
  small: PropTypes.bool,
  hidden: PropTypes.bool,
};

LanderLogo.defaultProps = {
  className: '',
  small: false,
  hidden: false,
};

export default memo(LanderLogo);
